<template>
  <div class="knowlitem-space">
    <div>
      <know-banner></know-banner>
    </div>
    <div class="knowledge-news">
      <el-row>
        <el-col :span="18">
          <div>
            <h2 class="know_item_title">专家解析</h2>
            <div class="doc-module-item" v-for="(item,index) in opinionList" :key="index">
              <div class="hr-type">
                <el-divider></el-divider>
              </div>
              <div>
                <el-row>
                  <el-col :span="6">
                    <div class="doc-module-img" @click="seeDocInfo(item.newsId)">
                      <img :src="item.newsMainImg" width="220" height="155" alt="">
                    </div>
                  </el-col>
                  <el-col :span="18">
                    <div>
                      <h3 @click="seeDocInfo(item.newsId)">{{item.newsTitle}}</h3>
                      <el-row>
                        <el-col :span='6'><span>时间：{{item.newsDate}}</span></el-col>
                        <el-col :span='8'><span>作者：{{item.newsCreateUserName}}</span></el-col>
                      </el-row>
                      <div>{{item.newsSummary}}</div>
                      <!-- <el-button type="text" class="know_module_more" @click="seeDocInfo(item.newsId)">更多<i class="el-icon-arrow-right el-icon--right"></i></el-button> -->
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
          <div class="news_page">
            <el-pagination :page-size="oPageSize" layout="prev, pager, next" :total="oTotalPage" @current-change="turnPage" background>
            </el-pagination>
          </div>
        </el-col>
        <el-col :span="6">
          <top-news v-bind:newsType="newsType"></top-news>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import knowBanner from './knowBanner';
import topNews from './topNews';
import { sysNewsData } from '@/api/frontApi/common';
export default {
  data() {
    return {
      opinionList: [],
      newsType: 10,
      topTenList: [],
      oPageSize: 5,
      oTotalPage: 1,
      oPageNo: 1
    };
  },
  components: {
    knowBanner,
    topNews
  },
  created() {
    this.initOpinionData();
    // this.topTenNews();
  },
  methods: {
    initOpinionData(pNo) {
      let params = {
        pageNo: this.oPageNo,
        pageSize: this.oPageSize,
        newsType: this.newsType
      };
      sysNewsData(params).then(res => {
        this.opinionList = res.data.list;
        this.oTotalPage = res.data.totalCount;
      });
    },
    seeDocInfo(textId) {
      this.$router.push({
        name: 'knowInfo',
        params: { knowledgeId: textId }
      });
    },
    turnPage(val) {
      this.oPageNo = val;
      this.initOpinionData();
    }
  }
};
</script>
<style scoped>
.hr-type {
  width: 93%;
}
.doc-module-item {
  width: 100%;
  margin: 0 auto;
}

.doc-module-img {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/knowledge/opinion.vue